import React from 'react';
import {
  Paper,
  Box,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';

export interface MetricsItem {
  label: string;
  value: React.ReactNode;
  icon?: React.ReactNode;
}

export interface MetricsCardProps {
  items: MetricsItem[];
}

const MetricsCard: React.FC<MetricsCardProps> = ({ items }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const cols = isMobile ? `repeat(auto-fill, minmax(80px,1fr))` : `repeat(${items.length}, 1fr)`;

  return (
    <Paper
      sx={{
        mb: 2,
        backgroundColor: '#1D6F78',
        borderRadius: 2,
        overflow: 'hidden',
        border: '1px solid',
        borderColor: 'rgba(255, 255, 255, 0.32)',
      }}
      elevation={0}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: cols,
          backgroundColor: '#1A2530',
          color: 'common.white',
          px: 2,
          py: 1,
          overflowX: isMobile ? 'auto' : undefined,
        }}
      >
        {items.map(({ label, icon }) => (
          <Box key={label} textAlign="center" sx={{ p: 1 }}>
            {isMobile ? (
              icon && (
                typeof icon === 'string' ? (
                  <Box
                    component="img"
                    src={icon}
                    alt={label}
                    sx={{ width: 24, height: 24, mb: 0.5, mx: 'auto' }}
                  />
                ) : icon
              )
            ) : (
              <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
                {icon && (
                  typeof icon === 'string' ? (
                    <Box
                      component="img"
                      src={icon}
                      alt={label}
                      sx={{ width: 16, height: 16 }}
                    />
                  ) : icon
                )}
                <Typography variant="body1">{label}</Typography>
              </Box>
            )}
          </Box>
        ))}

      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: cols,
          backgroundColor: '#1D6F78',
          color: 'common.white',
          px: 2,
          py: 1,
          overflowX: isMobile ? 'auto' : undefined,
        }}
      >
        {items.map(({ label, value }) => (
          <Box key={label} textAlign="center" sx={{ p: 1 }}>
            <Typography variant="h6">{value}</Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default MetricsCard;
